import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            动态快讯
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            最新动态
          </h2>
          <p className="text-foreground-500 mt-3 text-sm md:text-base max-w-xl mx-auto">
            吃瓜视频平台动态与剧集更新最新消息，追剧不迷路
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-0.5 bg-background-300"></div>

          <div className="space-y-0">
            {updatesData.map((update, index) => (
              <div key={index} className="relative flex items-start gap-5 md:gap-6 pb-7 last:pb-0 pl-12 md:pl-14">
                <div className="absolute left-3 md:left-4 top-1 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                <div className="flex-1 min-w-0">
                  <span className="text-xs font-medium text-primary-600">{update.date}</span>
                  <p className="text-sm md:text-base text-foreground-700 mt-1.5 leading-relaxed">
                    {update.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}